module.exports = __webpack_public_path__ + "assets/media/close-black.2fc20774.svg";